import { ListBoxSelect } from '@systemeio/ui'
import { SubAccountInterface } from 'modules/subaccounts/types/sub-account-interface'
import { useEffect, useState } from 'react'
import useUser from 'shared/hooks/use-user'
import { twJoin, twMerge } from 'tailwind-merge'
import { ChevronDownIcon } from '@systemeio/ui/icons'
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts'

interface SubAccountSelectorProps {
  className?: string
}

export const SubAccountSelector = ({ className }: SubAccountSelectorProps) => {
  const { dashboardUser, changeSubAccount, subAccountsData, avatarUrl } = useUser()

  const [selectedSubAccount, setSelectedSubAccount] = useState<SubAccountInterface | null>(null)

  useEffect(() => {
    if (dashboardUser && hasSubAccounts(dashboardUser)) {
      const selectedSubAccount =
        dashboardUser.subaccounts.find(subAccount => subAccount.user.id === dashboardUser.id) ??
        dashboardUser.mainUser

      setSelectedSubAccount(selectedSubAccount)
    }
  }, [dashboardUser])

  return hasSubAccounts(dashboardUser) ? (
    <ListBoxSelect
      optionsClassName={'z-50 cursor-pointer'}
      buttonClassName={'rounded-md'}
      value={selectedSubAccount?.user.id}
      onChange={value => changeSubAccount(value)}
      data={subAccountsData()}
    >
      {open => (
        <div
          className={twMerge(
            `border-text-secondary/30 flex flex-row items-center justify-between break-all rounded-md border bg-transparent px-4 py-2 text-black`,
            className,
          )}
        >
          <div className={'flex items-center gap-3'}>
            {avatarUrl && (
              <img
                className="h-[28px] w-[28px] min-w-[28px] overflow-hidden rounded-full object-cover"
                src={avatarUrl}
                alt={selectedSubAccount?.displayName}
              />
            )}
            <span className="truncate text-wrap text-start">{selectedSubAccount?.displayName}</span>
          </div>
          <ChevronDownIcon
            className={twJoin(`h-3 w-3 transition-transform`, open && 'rotate-180')}
            aria-hidden="true"
          />
        </div>
      )}
    </ListBoxSelect>
  ) : null
}
